"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _mapIconKeyToUiKit = _interopRequireDefault(require("../../../../../../utils/mapIconKeyToUiKit"));
var _AnnouncementsPanel = _interopRequireDefault(require("../AnnouncementsPanel"));
var _Nav = _interopRequireDefault(require("../Nav"));
var _Panel = _interopRequireDefault(require("../Panel"));
var _PanelItems = _interopRequireDefault(require("../PanelItems"));
const FooterMain = _ref => {
  let {
    items,
    announcementsRead,
    unreadAnnouncementsCount,
    announcements,
    selectedFooterSection,
    onSelectedFooterSectionChange,
    onFooterClose
  } = _ref;
  const selected = items.filter(x => (0, _mapIconKeyToUiKit.default)(x.icon) === selectedFooterSection);
  return /*#__PURE__*/_react.default.createElement("div", null, selectedFooterSection && (selectedFooterSection === 'announcements' ? /*#__PURE__*/_react.default.createElement(_AnnouncementsPanel.default, {
    announcements: announcements,
    onClose: onFooterClose
  }) : /*#__PURE__*/_react.default.createElement(_Panel.default, Object.assign({
    section: selectedFooterSection,
    onClose: onFooterClose
  }, selected[0]), /*#__PURE__*/_react.default.createElement(_PanelItems.default, {
    section: selectedFooterSection,
    subMenu: selected[0].subMenu
  }))), /*#__PURE__*/_react.default.createElement(_Nav.default, {
    announcementsRead: announcementsRead,
    unreadAnnouncementsCount: unreadAnnouncementsCount,
    selectedFooterSection: selectedFooterSection,
    items: items,
    onOpenItem: onSelectedFooterSectionChange
  }));
};
var _default = exports.default = FooterMain;